export const getCategories = ({
  servicesCategory = [],
  selectedServices = []
} = {}) =>
  servicesCategory.map(({ categoryName, services, iconName }) => ({
    categoryName,
    iconName,
    checked: services.some(({ skuId }) => selectedServices.includes(skuId))
  }))

export const getServicesPickerItems = ({
  servicesCategory = []
} = {}) =>
  servicesCategory.map(({ services }) =>
    services.map(({ skuId, displayName, averageSalePrice, autoSelect }) => ({
      label: displayName,
      value: skuId,
      revenue: averageSalePrice,
      autoSelect
    }))
  )

export const getAutoSelectedServicesInCategories = (servicesCategory = []) => {
  const allAutoSelectedServices = servicesCategory.map(({ services }) =>
    services.reduce((acc, { autoSelect, skuId }) => {
      if (autoSelect) {
        acc.push(skuId)
      }
      return acc
    }, []))

  const mergedServices = allAutoSelectedServices.reduce((a, b) => a.concat(b), [])
  const uniqueSelectedServices = [...new Set(mergedServices)]

  return uniqueSelectedServices
}
